import { z } from 'zod/v4';

export const eldPartnerTypeOptions = [
  'No Integration',
  'Integration Partner',
  'Common Partner Hub Integration',
] as const;

/**
 * Will transform object in response to appropriate, readable ELD Partner Type
 *
 * @example
 * {
 *  "eldPartnerTypeId": 0,
 *  "eldPartnerTypeDescription": "No Integration"
 * }
 * will map to:
 * eldPartnerType: 'No Integration'
 */
export const eldPartnerTypeSchema = z.preprocess((value) => {
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    if (
      'eldPartnerTypeId' in value &&
      typeof value.eldPartnerTypeId === 'number'
    ) {
      return eldPartnerTypeOptions[value.eldPartnerTypeId];
    }
  }
  return value;
}, z.enum(eldPartnerTypeOptions));

export type EldPartnerType = z.infer<typeof eldPartnerTypeSchema>;
